import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
import { LICENSE_STATUS } from "license/constants";
const LicenseStatus = ({ status }) => {
  const { t } = useTranslation("enterprise_license");
  switch (status) {
    case LICENSE_STATUS.active:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "success" }, t("license_status.active"));
    case LICENSE_STATUS.queued:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "primary" }, t("license_status.queued"));
    case LICENSE_STATUS.expired:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "warning" }, t("license_status.expired"));
    case LICENSE_STATUS.inactive:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "default" }, t("license_status.inactive"));
    default:
      return null;
  }
};
export default LicenseStatus;
